import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import * as Sentry from '@sentry/react';
import {
  NotFoundContainer,
  Section,
  Title,
  SubTitle,
  Link,
  Image,
  Column
} from './styled';

const NotFound = ({
  className,
  bg,
  linkTo,
  linkVariant,
  imageSrc,
  imageAlt,
  isReversed,
  imageOnBottom
}) => {
  Sentry.captureMessage(`Page not found: ${window.location.pathname}`);
  return (
    <>
      <Helmet>
        <meta name="prerender-status-code" content="404" />
      </Helmet>
      <NotFoundContainer className={className} bg={bg}>
        <Section isReversed={isReversed}>
          <Column>
            <Title>Oooops!</Title>
            <SubTitle>We can't find the page you're looking for.</SubTitle>
            <Link variant={linkVariant} to={linkTo}>
              Home
            </Link>
          </Column>
          <Image imageOnBottom={imageOnBottom}>
            <img src={imageSrc} alt={imageAlt} />
          </Image>
        </Section>
      </NotFoundContainer>
    </>
  );
};

NotFound.propTypes = {
  className: PropTypes.string,
  bg: PropTypes.string,
  imageSrc: PropTypes.string.isRequired,
  imageAlt: PropTypes.string.isRequired,
  linkTo: PropTypes.string.isRequired,
  linkVariant: PropTypes.string,
  isReversed: PropTypes.bool,
  imageOnBottom: PropTypes.bool
};

export default NotFound;
